import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const ArrowDownTwo = Styled(
	createSvgIcon(
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M13.28 5.96667L8.9333 10.3133C8.41997 10.8267 7.57997 10.8267 7.06664 10.3133L2.71997 5.96667'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeMiterlimit='10'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>,
		'ArrowDownTwo'
	)
);

export default ArrowDownTwo;
